import React, { useRef, useEffect } from "react";

const TextAreaInput = ({
  id,
  label,
  value,
  onChange,
  placeholder = "",
  disabled = false,
  invalid = false,
  required = false,
  labelPosition = "left", // "top" | "left"
}) => {
  const textareaRef = useRef(null);
  const isTop = labelPosition === "top";

  // Auto-resize based on content
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div
      className={`w-full mb-4 ${isTop
          ? "flex flex-col gap-1"
          : "flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4"
        }`}
    >
      {label && (
        <label
          htmlFor={id}
          className={`text-base font-medium text-black ${isTop ? "" : "whitespace-nowrap"
            }`}
        >
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}

      <textarea
        ref={textareaRef}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className={`w-full px-2 py-2 border-0 border-b-2 rounded-md overflow-hidden resize-none
          ${invalid ? "border-b-red-500" : "border-b-gray-300"}
          focus:outline-none focus:ring-2 focus:ring-blue-600
          bg-slate-50 
          ${!isTop ? "sm:flex-1" : ""}
          ${disabled ? "!text-black !opacity-100 font-small" : "font-medium"}
        `}
      />
    </div>
  );
};

export default TextAreaInput;
